/**
 * @file Renders the shared heading and text layout for an Authenticator step.
 */
import { View, Text, Heading } from "@aws-amplify/ui-react";

type Props = {
  text?: string;
  heading?: string;
};

/**
 * Renders an optional heading and an optional text line, spaced to sit
 * below the heading when both are given.
 */
const FormHeader = ({
  text = undefined,
  heading = undefined,
}: Props): JSX.Element => {
  return (
    <View>
      {
        heading && (
          <Heading level={4}>
            {heading}
          </Heading>
        )
      }

      {
        text && (
          <Text style={{ marginTop: heading ? 10 : 0 }}>
            {text}
          </Text>
        )
      }
    </View>
  );
};

export default FormHeader;
